/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ContainerFinance_container = {
    readonly slug: string;
    readonly finances: ReadonlyArray<{
        readonly label: string;
        readonly value: string | null;
    }> | null;
    readonly " $refType": "ContainerFinance_container";
};
export type ContainerFinance_container$data = ContainerFinance_container;
export type ContainerFinance_container$key = {
    readonly " $data"?: ContainerFinance_container$data;
    readonly " $fragmentRefs": FragmentRefs<"ContainerFinance_container">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContainerFinance_container",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValueField",
      "kind": "LinkedField",
      "name": "finances",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Container",
  "abstractKey": null
};
(node as any).hash = '036aaf4939f319d01e9d66df7b881f85';
export default node;
